export default (i: string) => {
  return !!i && !isNaN(Number(i)) ? Number(i) : i;
};